module.exports = __webpack_public_path__ + "static/img/bridge.978c16a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bridge.jpg
// module id = 14
// module chunks = 1